import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Sidebar from './components/Layout/Sidebar';
import ChatPage from './pages/ChatPage';
import AgentsPage from './pages/AgentsPage';
import AgentExplorerPage from './pages/AgentExplorerPage';
import ApiDocsPage from './pages/ApiDocsPage';
import CurlCommandsPage from './pages/CurlCommandsPage';
import OcrWidgetPage from './pages/OcrWidgetPage';
import CreateAgentPage from './pages/CreateAgentPage';
import BillingPage from './pages/BillingPage';
import SettingsPage from './pages/SettingsPage';
import ApiTestingPage from './pages/ApiTestingPage';
import DeploymentPage from './pages/DeploymentStudioPage';
import DeploymentPreviewPage from './pages/DeploymentPreviewPage';
import ClientManagementPage from './pages/ClientManagementPage';
import PluginsPage from './pages/PluginsPage';
import LoginPage from './pages/LoginPage';

function App() {
  const [authenticated, setAuthenticated] = useState(() => {
    return localStorage.getItem('launchpad_auth') === 'true';
  });

  // Standalone deployed mode — window.__CONFIG__ is set by the server
  const isStandalone = !!(window as any).__CONFIG__?.agents;

  if (isStandalone) {
    // Deployed app mode — show the universal app shell directly
    return (
      <Router>
        <Routes>
          <Route path="*" element={<DeploymentPreviewPage />} />
        </Routes>
        <Toaster position="top-right" />
      </Router>
    );
  }

  if (!authenticated) {
    return (
      <>
        <LoginPage onLogin={() => setAuthenticated(true)} />
        <Toaster position="top-right" />
      </>
    );
  }

  return (
    <Router>
      <Routes>
        {/* Standalone preview route (no sidebar — used in iframe) */}
        <Route path="/deployment-preview" element={<DeploymentPreviewPage />} />

        {/* Main app with sidebar */}
        <Route path="*" element={
          <div className="flex h-screen bg-gray-50">
            <Sidebar />
            <div className="flex-1 overflow-hidden">
              <Routes>
                <Route path="/" element={<ChatPage />} />
                <Route path="/agents" element={<AgentsPage />} />
                <Route path="/explorer" element={<AgentExplorerPage />} />
                <Route path="/api-docs" element={<ApiDocsPage />} />
                <Route path="/curl-commands" element={<CurlCommandsPage />} />
                <Route path="/ocr" element={<OcrWidgetPage />} />
                <Route path="/create-agent" element={<CreateAgentPage />} />
                <Route path="/test" element={<ApiTestingPage />} />
                <Route path="/billing" element={<BillingPage />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="/deployment" element={<DeploymentPage />} />
                <Route path="/clients" element={<ClientManagementPage />} />
                <Route path="/plugins" element={<PluginsPage />} />
              </Routes>
            </div>
          </div>
        } />
      </Routes>
      <Toaster position="top-right" />
    </Router>
  );
}

export default App;
